import { ActionFeedback, Back, ButtonSecondary, Loading, OmnijusCard, SelectObject } from "@omnijus/common";
import { WrapperAcessoAcaoOperacional } from "../../contexts/acessos-helper";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { IdStatusPeticionamento } from "../../services/peticionamento/models/id-status-peticionamento";
import { SolicitacaoPeticionamentoListada } from "../../services/peticionamento/models/solicitacao-peticionamento-listada";
import { SolicitacaoPeticionamentoMotivoReprovacao } from "../../services/peticionamento/models/solicitacao-peticionamento-motivo-reprovacao";
import {
    encaminharAnaliseEscritorio,
    listarSolicitacaoPeticionamentoMotivoReprovacao,
    obterSolicitacaoPeticionamento,
    responderSolicitacaoPeticionamento,
} from "../../services/peticionamento/peticionamento-service";
import { TipoDocumentoService } from "../../services/tipo-documento/tipo-documento-service";
import { ButtonPrimary } from "../../shared/form/fields/omnijus-button-primary";
import { CardInfoSolicitacaoPeticionamento } from "./card-info-solicitacao-peticionamento";
import { CardMovimentoGerador } from "./card-movimento-gerador";
import { DocumentosProcesso } from "./documentos-processo";
import { ListaDocumentosPeticionamento } from "./lista-documentos-peticionamento";
import styles from "./listar-peticionamentos.module.scss";
import { ModalAprovarComRessalva } from "./modal-aprovar-com-ressalva";
import { ModalIncluirDocumentos } from "./modal-incluir-documentos";
import { ModalMotivosReprovacao } from "./modal-motivos-reprovacao";
import { ModalReprovar } from "./modal-reprovar";
import { PdfViewer } from "./pdf-viewer";

export const DocumentosPeticionamento = () => {
    const [motivosReprovacao, setMotivosReprovacao] = useState<SolicitacaoPeticionamentoMotivoReprovacao[]>();
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalAprovarComRessalvaOpen, setModalAprovarComRessalvaOpen] = useState(false);
    const [isModalReprovarOpen, setModalReprovarOpen] = useState(false);
    const [isModalMotivosReprovacaoOpen, setModalMotivosReprovacaoOpen] = useState(false);
    const [promise, setPromise] = useState<Promise<SolicitacaoPeticionamentoListada | undefined>>();
    const [documentoSelecionado, setDocumentoSelecionado] = useState<SelectObject | undefined>();
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const [tiposDocumento, setTiposDocumento] = useState<
        {
            id: number;
            value: string;
        }[]
    >();

    const handleDocumentoSelecionado = useCallback((documentoSelecionado: SelectObject | undefined) => {
        setDocumentoSelecionado(documentoSelecionado);
    }, []);

    useEffect(() => {
        (async () => {
            if (id) {
                setMotivosReprovacao(await listarSolicitacaoPeticionamentoMotivoReprovacao(id));
                const result = await TipoDocumentoService.listarCombo(true);

                setTiposDocumento(result);

                setPromise(obterSolicitacaoPeticionamento(id));
            }
        })();
    }, [id]);

    return (
        <Loading promise={promise}>
            {(solicitacaoPeticionamento) =>
                solicitacaoPeticionamento && (
                    <>
                        <Back />

                        <h1 className={styles.titulo}>
                            Validação de: {solicitacaoPeticionamento.descricaoProvidencia}
                        </h1>

                        <CardInfoSolicitacaoPeticionamento
                            idSolicitacaoPeticionamento={solicitacaoPeticionamento.idSolicitacaoPeticionamento}
                            statusSolicitacaoPeticionamento={solicitacaoPeticionamento.statusSolicitacaoPeticionamento}
                            nomeCliente={solicitacaoPeticionamento.nomeCliente}
                            numeroProcesso={solicitacaoPeticionamento.numeroProcesso}
                            nomeEscritorio={solicitacaoPeticionamento.nomeEscritorio}
                            modal="2Colunas"
                            descricaoProvidencia={solicitacaoPeticionamento.descricaoProvidencia}
                        />

                        <div className={`${styles.botoesSuperiores}`}>
                            {motivosReprovacao && motivosReprovacao.length > 0 && (
                                <ButtonSecondary
                                    onClick={() => {
                                        setModalMotivosReprovacaoOpen(true);
                                    }}
                                >
                                    Ver motivos de reprovação
                                </ButtonSecondary>
                            )}

                            {solicitacaoPeticionamento.idStatusSolicitacaoPeticionamento ===
                                IdStatusPeticionamento.ReprovadoEscritorio && (
                                <WrapperAcessoAcaoOperacional tags={["encaminhar_analise_escritorio"]}>
                                    <ButtonSecondary
                                        onClick={async () => {
                                            await ActionFeedback.processing({
                                                title: "Processando...",
                                                execution: encaminharAnaliseEscritorio(
                                                    solicitacaoPeticionamento.idSolicitacaoPeticionamento
                                                ),
                                                onError: async (error: any) =>
                                                    await ActionFeedback.error({
                                                        icon: "error",
                                                        html: error?.json?.erros
                                                            ? error.json.erros.join("<br />")
                                                            : error?.json?.title
                                                            ? error?.json?.title
                                                            : "Não foi possível concluir esta operação. Tente novamente mais tarde.",
                                                    }),
                                            });

                                            await ActionFeedback.info({
                                                text: "Encaminhado para análise do escritório!",
                                            });

                                            window.location.reload();
                                        }}
                                    >
                                        Encaminhar Análise Escritório
                                    </ButtonSecondary>
                                </WrapperAcessoAcaoOperacional>
                            )}

                            {solicitacaoPeticionamento.permitirIncluirDocPeticionamento &&
                                solicitacaoPeticionamento.idStatusSolicitacaoPeticionamento ===
                                    IdStatusPeticionamento.PendenteAprovacao && (
                                    <>
                                        <ButtonPrimary
                                            onClick={() => {
                                                setModalOpen(true);
                                            }}
                                        >
                                            Incluir Documentos
                                        </ButtonPrimary>
                                        <ButtonPrimary
                                            onClick={() => history.push("/peticionamentos")}
                                            className={`${styles.botaoSalvar}`}
                                        >
                                            Concluir
                                        </ButtonPrimary>
                                    </>
                                )}
                        </div>

                        <div className={styles.marginTop}>
                            {solicitacaoPeticionamento.idSolicitacaoPeticionamento && (
                                <>
                                    <div className={styles.formIncluirDocumentos}>
                                        <div style={{ overflow: "auto" }}>
                                            <CardMovimentoGerador
                                                handleDocumentoSelecionado={handleDocumentoSelecionado}
                                                idProcesso={solicitacaoPeticionamento.idProcesso}
                                                idProcessoMovimento={solicitacaoPeticionamento.idProcessoMovimento}
                                            />

                                            <ListaDocumentosPeticionamento
                                                handleDocumentoSelecionado={handleDocumentoSelecionado}
                                                idProcesso={solicitacaoPeticionamento.idProcesso}
                                                idSolicitacaoPeticionamento={
                                                    solicitacaoPeticionamento.idSolicitacaoPeticionamento
                                                }
                                                idStatusSolicitacaoPeticionamento={
                                                    solicitacaoPeticionamento.idStatusSolicitacaoPeticionamento
                                                }
                                                documentoSelecionado={documentoSelecionado}
                                            />

                                            <DocumentosProcesso
                                                handleDocumentoSelecionado={handleDocumentoSelecionado}
                                                idProcesso={solicitacaoPeticionamento.idProcesso}
                                            />
                                        </div>

                                        {documentoSelecionado && (
                                            <div>
                                                <PdfViewer documentoSelecionado={documentoSelecionado} />
                                            </div>
                                        )}
                                    </div>

                                    {solicitacaoPeticionamento.idStatusSolicitacaoPeticionamento ===
                                        IdStatusPeticionamento.PendenteAprovacao && (
                                        <div className={styles.marginTop}>
                                            <OmnijusCard
                                                body={
                                                    <div className={styles.botoes}>
                                                        {solicitacaoPeticionamento.possuiDocumentos && (
                                                            <ButtonPrimary
                                                                onClick={async () => {
                                                                    await ActionFeedback.processing({
                                                                        title: "Aprovando solicitação de peticionamento",
                                                                        execution: responderSolicitacaoPeticionamento(
                                                                            solicitacaoPeticionamento.idSolicitacaoPeticionamento,
                                                                            true
                                                                        ),
                                                                        onError: async (error: any) =>
                                                                            await ActionFeedback.error({
                                                                                icon: "error",
                                                                                html: error?.json?.erros
                                                                                    ? error.json.erros.join("<br />")
                                                                                    : error?.json?.title
                                                                                    ? error?.json?.title
                                                                                    : "",
                                                                            }),
                                                                    });

                                                                    await ActionFeedback.info({
                                                                        title: "Solicitação de peticionamento aprovada",
                                                                    });

                                                                    window.location.reload();
                                                                }}
                                                                className={`${styles.botao} ${styles.botaoSalvar}`}
                                                            >
                                                                Aprovar
                                                            </ButtonPrimary>
                                                        )}

                                                        {solicitacaoPeticionamento.possuiDocumentos && (
                                                            <ButtonPrimary
                                                                onClick={() => setModalAprovarComRessalvaOpen(true)}
                                                                className={`${styles.botao} ${styles.botaoAprovarComRessalva}`}
                                                            >
                                                                Aprovar com ressalva
                                                            </ButtonPrimary>
                                                        )}

                                                        <ButtonPrimary
                                                            onClick={() => setModalReprovarOpen(true)}
                                                            className={`${styles.botao} ${styles.botaoSair}`}
                                                        >
                                                            Reprovar
                                                        </ButtonPrimary>
                                                    </div>
                                                }
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        {tiposDocumento && solicitacaoPeticionamento.idSolicitacaoPeticionamento && (
                            <ModalIncluirDocumentos
                                nomeCliente={solicitacaoPeticionamento.nomeCliente}
                                numeroProcesso={solicitacaoPeticionamento.numeroProcesso}
                                statusSolicitacaoPeticionamento={
                                    solicitacaoPeticionamento.statusSolicitacaoPeticionamento
                                }
                                nomeEscritorio={solicitacaoPeticionamento.nomeEscritorio}
                                tiposDocumento={tiposDocumento}
                                isModalOpen={isModalOpen}
                                onCloseModal={() => setModalOpen(false)}
                                idSolicitacaoPeticionamento={solicitacaoPeticionamento.idSolicitacaoPeticionamento}
                            />
                        )}

                        {solicitacaoPeticionamento.idSolicitacaoPeticionamento && (
                            <ModalAprovarComRessalva
                                idSolicitacaoPeticionamento={solicitacaoPeticionamento.idSolicitacaoPeticionamento}
                                nomeCliente={solicitacaoPeticionamento.nomeCliente}
                                numeroProcesso={solicitacaoPeticionamento.numeroProcesso}
                                statusSolicitacaoPeticionamento={
                                    solicitacaoPeticionamento.statusSolicitacaoPeticionamento
                                }
                                nomeEscritorio={solicitacaoPeticionamento.nomeEscritorio}
                                descricaoProvidencia={solicitacaoPeticionamento.descricaoProvidencia}
                                isModalOpen={isModalAprovarComRessalvaOpen}
                                onCloseModal={() => setModalAprovarComRessalvaOpen(false)}
                            />
                        )}

                        {solicitacaoPeticionamento.idSolicitacaoPeticionamento &&
                            solicitacaoPeticionamento.idProvidencia && (
                                <ModalReprovar
                                    idSolicitacaoPeticionamento={solicitacaoPeticionamento.idSolicitacaoPeticionamento}
                                    nomeCliente={solicitacaoPeticionamento.nomeCliente}
                                    numeroProcesso={solicitacaoPeticionamento.numeroProcesso}
                                    statusSolicitacaoPeticionamento={
                                        solicitacaoPeticionamento.statusSolicitacaoPeticionamento
                                    }
                                    nomeEscritorio={solicitacaoPeticionamento.nomeEscritorio}
                                    idProvidencia={solicitacaoPeticionamento.idProvidencia}
                                    descricaoProvidencia={solicitacaoPeticionamento.descricaoProvidencia}
                                    isModalOpen={isModalReprovarOpen}
                                    onCloseModal={() => setModalReprovarOpen(false)}
                                />
                            )}

                        {motivosReprovacao && (
                            <ModalMotivosReprovacao
                                isModalOpen={isModalMotivosReprovacaoOpen}
                                onCloseModal={() => setModalMotivosReprovacaoOpen(false)}
                                motivosReprovacao={motivosReprovacao}
                            />
                        )}
                    </>
                )
            }
        </Loading>
    );
};
